// extracted by mini-css-extract-plugin
export default {"whiteColor":"#fff","blackColor":"#121212","grayColor":"gray","lightGrayColor":"#ccc","subItemColor":"#3f51b5","errorColor":"red","middleGrayColor":"silver"};